import React from "react";
import { func, bool, string } from "prop-types";
import Loadericon from "../load-more-button-loader/index";
import "./load-more-btn.m.css";

export const More = ({ onClick, text, showButtonSpinner = false }) => {
  return (
    <div styleName="wrapper" className="more" onClick={onClick}>
      <span styleName="content bn-content">
        {text}
        {showButtonSpinner && <Loadericon />}
      </span>
    </div>
  );
};

More.propTypes = {
  onClick: func,
  text: string,
  showButtonSpinner: bool
};
